import UIComponent from "../component";

export class LinkMail extends UIComponent {
    init() {
        this.includeComponents({
            toast: 'document@[data-tbx-name="copyMessage"]',
        });
        
        this.on('click', (e) => {
            e.preventDefault();
            this.copyMailToClipboard();
        });
    }

    async copyMailToClipboard() {
        try {
            const mail = this.mail ;
            
            if (!mail) {
                console.error('Не удалось найти почту для копирования');
                return;
            }
            
            if (navigator.clipboard?.writeText) {
                await navigator.clipboard.writeText(mail);
            } else {
                const textArea = document.createElement("textarea");
                textArea.value = mail;
                textArea.style.position = "fixed";
                textArea.style.left = "-9999px";
                document.body.appendChild(textArea);
                textArea.select();
                document.execCommand("copy");
                document.body.removeChild(textArea);
            }
            
            if (this.toast && this.toast.show) {
                this.toast.element.textContent = 'Почта скопирована';
                this.toast.show();
                setTimeout(() => {
                    if (this.toast && this.toast.hide) {
                        this.toast.hide();
                    }
                }, 2000);
            }
            
        } catch (e) {
            console.error("Copy failed:", e);
        }
    }
}